/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    saveSubmissionErrorTitle: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Unable to save submission',
        defaultMessage: 'Unable to save submission'
    },
    saveSubmissionErrorMessage: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Error save quote submission',
        defaultMessage: 'An error occurred while attempting to save quote submission.'
    },
    policyTypeChangedWarning: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.policyTypeChangedWarning',
        defaultMessage: '{firstLine}{lineBreak}{secondLine}'
    },
    policyTypeChangedWarningFirstLine: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.policyTypeChangedWarningFirstLine',
        defaultMessage: 'Based on the information entered, the policy type has been changed'
    },
    policyTypeChangedWarningSecondLine: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.policyTypeChangedWarningSecondLine',
        defaultMessage: 'Please review before proceeding'
    },
    OriginalEffectiveDate: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.OrioginalEffectiveDate',
        defaultMessage: 'Please enter a valid date in a MM/YYYY format for the Original Effective Date of your prior policy.'
    },
    FutureEffectiveDate: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.FutureEffectiveDate',
        defaultMessage: 'Original Effective Date of your prior policy cannot be greater than current date.'
    },
    baseWizardMessageNonRenters: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.wizardMessageHome',
        defaultMessage: 'Next, we’ll {boldText}'
    },
    baseWizardMessageRenters: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.wizardMessageRent',
        defaultMessage: 'Next, we’ll {boldText}!'
    },
    reviewHomeDetails : {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.propertyDetails',
        defaultMessage: 'review your home details'
    },
    reviewQuote: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.quote',
        defaultMessage: 'review your quote'
    },
    dateCannotBePriorYearBuilt: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Date entered cannot be prior to Year Built',
        defaultMessage: '{nameOfModifier}: Date entered cannot be prior to Year Built'
    },
    importantReminder: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Important Reminder',
        defaultMessage: 'Important Reminder'
    },
    confirmEmailAddress: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.confirmEmailAddress',
        defaultMessage: 'Customer will receive email to validate Smart Home device at {email}. Confirm email address on Profile Details page.'
    },
    warningMessage: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.warningMessage',
        defaultMessage: '{importantReminder} {confirmEmailAddress}'
    },
    nextDescription: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.nextDescription',
        defaultMessage: 'We\'ll need some {additionalInformation} next'
    },
    additionalInformation: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.additional information',
        defaultMessage: 'additional information'
    },
    primaryHeatingType: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.What type of fuel is used by your heating system?',
        defaultMessage: 'What type of fuel is used by your heating system?'
    },
    oilTankUnderground: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Is your oil tank buried underground',
        defaultMessage: 'Is your oil tank buried underground?'
    },
    oilTankDecommissioned: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Has this tank been decommissioned?',
        defaultMessage: 'Has this tank been decommissioned?'
    },
    oilTankDecommissionedTooltipTitle: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.tooltip.What is meant by decommissioned?',
        defaultMessage: 'What is meant by decommissioned?'
    },
    oilTankDecommissionedTooltipContent: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.tooltip.oilTankDecommissionedTooltipContent',
        defaultMessage: 'Decommissioned means to take the tank out of service by cleaning it, then removing it or filling it in place with sand, rock or concrete.  Simply emptying a tank, by itself, is not enough to consider the tank decommissioned.'
    },
    roofUpgradeDate: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.What year was the roof installed or updated?',
        defaultMessage: 'What year was the roof installed or updated?'
    },
    emailAddress: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Email Address',
        defaultMessage: 'Email Address'
    },
    enterEmailAddress: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Enter email address',
        defaultMessage: 'Enter email address'
    },
    emailOptional: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Email Optional',
        defaultMessage: 'Email (Optional)'
    },
    emailScriptHeader: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Email Script',
        defaultMessage: 'Email Script'
    },
    emailScriptContent: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.emailScriptContent',
        defaultMessage: 'When you provide your email address, you consent to receiving emails about your online quote and other product information from third parties working for us who we gave your email address.  We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes.  To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    showAnimalExclusionWarningMessage: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.',
    },
    electronicToPaperWarning: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.A valid email address is required to receive electronic communications.',
        defaultMessage: '<b>A valid email address is required to receive electronic communications. If you don’t enter an email address, the paperless discount will be removed.</b><br></br>Please review before proceeding.'
    },
    verifyEmail: {
        id:'ml.common.component.GatewayCompRaterHOValidationInformationPage.verifyEmail',
        defaultMessage:"Enter a valid email address"
    },
    invalidEmail: {
        id:'ml.common.component.GatewayCompRaterHOValidationInformationPage.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    somethingWentWrong: {
        id:'ml.common.component.GatewayCompRaterHOValidationInformationPage.Something went wrong during this process.  Please try again.',
        defaultMessage:"Something went wrong during this process.  Please try again."
    },
    closeWindow: {
        id: 'ml.common.component.Close Window',
        defaultMessage: 'Close Window'
    },
    dateCannotBeAfterTodaysDate: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Date entered cannot be after todays date',
        defaultMessage: '{nameOfModifier}: Date entered cannot be after today\'s date'
    },
    dwellingTypeLabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Is the dwelling a mobile home, trailer, modular or manufactured home?',
        defaultMessage: 'Is the dwelling a mobile home, trailer or manufactured home?'
    },
    cuurentMarketValueLabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Current market value minus land or ACV',
        defaultMessage: 'Current market value minus land or ACV'
    },
    dwellingClassificationLabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Dwelling Classification',
        defaultMessage: 'Dwelling Classification'
    },
    uderConstructionLabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Is the dwelling under construction?',
        defaultMessage: 'Is the dwelling under construction?'
    },
    typeOfConstructionLabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.What type of construction is it?',
        defaultMessage: 'What type of construction is it?'
    },
    includePPLossofUselabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Do you want to include coverage for Personal Property and Loss of Use',
        defaultMessage: 'Do you want to include coverage for Personal Property and Loss of Use?'
    },
    solarpanelLabel: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Are there any solar panels at the premises?',
        defaultMessage: 'Are there any solar panels at the premises?'
    },
    underConstructionNotification: {
        id: `ml.common.component.GatewayCompRaterHOValidationInformationPage.Under Construction Notification`,
        defaultMessage: `Policy will be endorsed with Course of Construction endorsement`
    },
    homeSharingAirBnbSelectedNotification: {
        id: `ml.common.component.GatewayCompRaterHOValidationInformationPage.Home Sharing AirBnb Selected Notification`,
        defaultMessage: `Home Sharing is not covered unless the Home Sharing Endorsement is selected in Optional Coverages and included in the policy. `
    },
    firstPersonInControl: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.PNI.FirstPersonInControl',
        defaultMessage: 'First Person in Control'
    },
    primaryNamedInsured: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.PrimaryNamedInsured',
        defaultMessage: 'Primary Named Insured'
    },
    sniPersonInControl: {
       id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.sniPersonInControl',
            defaultMessage: 'Second Person in Control'
    },
    sniNamedInsured: {
         id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.sniNamedInsured',
            defaultMessage: 'Secondary Named Insured'
    },
    roofUpgradeDateForNP: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.What year was the roof installed or completely updated?',
        defaultMessage: 'What year was the roof installed or completely updated?'
    },
    cmvTooltip: {
        id: `ml.common.component.GatewayCompRaterHOValidationInformationPage.tooltip.CMVToolTip`,
        defaultMessage: `<p>Current Market Value — The price a buyer would be willing to pay for the dwelling, minus the value of the land. To the public, current market value generally includes non-insured elements of the property, such as land and foundation, which reflects surrounding real estate market conditions. The current market value for insurance coverage purposes, and consequently for any claim settlement, does not include the non-insured elements. The rating base should reflect only the current market value for insurance coverage purposes.</p><p>Actual Cash Value — The cost to repair or replace property with conventional materials of like kind and quality, less allowance for physical deterioration and depreciation, including obsolescence.</p>`
    },
    tenantScreeningTooltip: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Tenant screenings Tooltip',
        defaultMessage:
            '<b>Credit check:</b> The landlord orders and reviews the tenant\'s credit report history.<br></br>' +
            '<br></br><b>Criminal background check:</b> The landlord orders a report the tenant\'s criminal record including prior convictions.<br></br>' +
            '<br></br><b>Eviction search:</b> The landlord orders a report of the prior tenant evictions.<br></br>' +
            '<br></br><b>HO4 tenant policy on file:</b> The landlord maintains a copy of the tenant\'s HO4 policy.<br></br>' +
            '<br></br><b>Skip search:</b> The landlord orders a report of the tenant\'s prior unfulfilled lease agreements.'
    },
    inValidOptionselected: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.Invalid Option selected',
        defaultMessage: '“None apply” cannot be selected with other options. Please update your selections.'
    },
    currentMarketValueError: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.current market value error',
        defaultMessage: `Current market value minus land or ACV value should be in multiple's of 1000.`
    },
    missingDob: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.missingDob',
        defaultMessage: `SNI Date of Birth is required`
    },
    producerCodeChanged: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.producerCodeChanged',
        defaultMessage: 'This producer does not have an active license, appointment, or state authority for this quote. To continue, we have automatically updated the producer code to the primary group producer. If you are a non-licensed (NL) user or would like to be appointed, please contact Agency Contract Management at 1-800-237-6136 for assistance. '
    },
    selectDiffProducerCode: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.selectDiffProducerCode',
        defaultMessage: 'Please try selecting a different producer code.'
    },
    missingTenant: {
        id: 'ml.common.component.GatewayCompRaterHOValidationInformationPage.missingTenant',
        defaultMessage: 'Please provide the missing required tenant screening value.'
    }
});